import { render, staticRenderFns } from "./ContentLayout.vue?vue&type=template&id=69650244&scoped=true&"
import script from "./ContentLayout.vue?vue&type=script&lang=js&"
export * from "./ContentLayout.vue?vue&type=script&lang=js&"
import style0 from "./ContentLayout.vue?vue&type=style&index=0&id=69650244&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69650244",
  null
  
)

export default component.exports